import axios from 'axios';

const API_URL = '/api';

// Add axios interceptor to automatically include auth token
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const eventService = {
  getAllEvents: (filters = {}) => {
    const params = new URLSearchParams(filters);
    return axios.get(`${API_URL}/events?${params}`);
  },

  getEventById: (id) => {
    return axios.get(`${API_URL}/events/${id}`);
  },

  createEvent: (eventData) => {
    return axios.post(`${API_URL}/events`, eventData);
  },

  updateEvent: (id, eventData) => {
    return axios.put(`${API_URL}/events/${id}`, eventData);
  },

  deleteEvent: (id) => {
    return axios.delete(`${API_URL}/events/${id}`);
  },

  getMyEvents: () => {
    return axios.get(`${API_URL}/events/my-events`);
  },

  getPendingEvents: () => {
    return axios.get(`${API_URL}/events/pending`);
  },

  reviewEvent: (id, status, rejectionReason) => {
    return axios.patch(`${API_URL}/events/${id}/review`, { status, rejectionReason });
  }
};

export const notificationService = {
  getNotifications: () => {
    return axios.get(`${API_URL}/notifications`);
  },

  markRead: (id) => {
    return axios.patch(`${API_URL}/notifications/${id}/read`);
  },

  markAllRead: () => {
    return axios.patch(`${API_URL}/notifications/read-all`);
  }
};

export const organizerService = {
  getAllOrganizers: () => {
    return axios.get(`${API_URL}/organizers`);
  },

  getOrganizer: (id) => {
    return axios.get(`${API_URL}/organizers/${id}`);
  },

  updateOrganizer: (id, organizerData) => {
    return axios.put(`${API_URL}/organizers/${id}`, organizerData);
  }
};
